var crypto = window.crypto || window.msCrypto

module.exports = function (bytes) {
  return crypto.getRandomValues(new Uint8Array(bytes))
}



//////////////////
// WEBPACK FOOTER
// ./~/nanoid/random-browser.js
// module id = 1366
// module chunks = 0